import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import exclamationCircle from './images/exclamation-circle-solid.svg'
import i18n from './translations/i18n';

let DavronFormErrorPage = props => {
	let lng = props.lng;
	return (
		<div>
			<CSSTransitionGroup
				transitionName="davron"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={300}
			>
			
				<div className="text-center">
					<img src={exclamationCircle} alt="exclamation-circle" className="check-circle"/>
					<div>
						<h1 className="mt-5 mb-3">{i18n.t('error_page.main_text', {lng})}</h1>
						<h2>{i18n.t('error_page.secondary_text', {lng})}</h2>
						<h6>{i18n.t('error_page.reference_name', {lng})}</h6>
					</div>
					<div className="mt-5">
						<button onClick={props.reloadForm} className="btn btn-orange btn-large">{i18n.t('error_page.button', {lng})}</button>
					</div>

				</div>

			</CSSTransitionGroup>
		</div>
	)
}

export default DavronFormErrorPage;


// WEBPACK FOOTER //
// ./src/DavronFormErrorPage.js